import React, { Component } from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import normalizeCss from "normalize.css";
import bootstrapCss from "bootstrap/dist/css/bootstrap.css";
import pagTableStyles from "react-table/react-table.css";
import fullCalendarBaseStyles from "fullcalendar/dist/fullcalendar.min.css";
import reactTostifyStyles from "react-toastify/dist/ReactToastify.min.css";
import reactTimesCss from "react-times/css/classic/default.css";
import rcTreeStyles from "rc-tree/assets/index.css";
import s from "./OBFrame.styles.scss";
import logo from "../../media/images/sports_logo.png";
import OBNotification from "../OBNotification/OBNotification.component";

interface Props {
  windowTitle: string;
  title: string;
  subTitle?: string;
}

interface State {}

class OBFrameUnstyled extends Component<Props, State> {
  componentDidMount(): void {
    document.title = this.props.windowTitle || "Sports World";
  }

  render() {
    return (
      <div className={s.layoutRoot}>
        <OBNotification {...({} as any)} />
        <div className={s.content}>{this.props.children}</div>
      </div>
    );
  }
}

const OBFrame = withStyles(
  normalizeCss,
  bootstrapCss,
  pagTableStyles,
  reactTostifyStyles,
  fullCalendarBaseStyles,
  reactTimesCss,
  rcTreeStyles,
  s
)(OBFrameUnstyled);

export default OBFrame;
